import { KycVerificationListConstants } from "../_constants";

export default function kyc(state = {}, action) {
  switch (action.type) {
    // kyc verification list data
    case KycVerificationListConstants.GET_KYCVERIFICATION_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case KycVerificationListConstants.GET_KYCVERIFICATION_LIST_SUCCESS:
      return {
        ...state,

        loading: false,
        getkycVerificationList: action?.user,
      };
    case KycVerificationListConstants.GET_KYCVERIFICATION_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };


    // MERCHANT KYC LIST DATA

    case KycVerificationListConstants.GET_MERCHANT_KYC_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case KycVerificationListConstants.GET_MERCHANT_KYC_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        merchantKycList: action?.user?.data?.list,
        merchantKycListTotal: action?.user?.data?.total,

      };
    case KycVerificationListConstants.GET_MERCHANT_KYC_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };




    case KycVerificationListConstants.GET_KYC_EXPIRE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case KycVerificationListConstants.GET_KYC_EXPIRE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        merchantKycExpireList: action?.user?.data?.list,
        merchantKycExpireListTotal: action?.user?.data?.total,

      };
    case KycVerificationListConstants.GET_KYC_EXPIRE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };




    // kyc user details list data
    case KycVerificationListConstants.GET_USERKYCDETAILS_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case KycVerificationListConstants.GET_USERKYCDETAILS_LIST_SUCCESS:
      return {
        ...state,

        loading: false,
        getkycVerificationList: action?.user,
      };
    case KycVerificationListConstants.GET_USERKYCDETAILS_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    //Update user kyc details
    case KycVerificationListConstants.UPDATE_USER_KYCDETAILS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case KycVerificationListConstants.UPDATE_USER_KYCDETAILS_SUCCESS:
      return {
        ...state,

        loading: false,

      };
    case KycVerificationListConstants.UPDATE_USER_KYCDETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    default:
      return state;
  }
}
